'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExtendableError = require('./ExtendableError');

var _ExtendableError2 = _interopRequireDefault(_ExtendableError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Typed error for when no location with a given id exists
 * @param {string} courseId
 */
class LocationDoesNotExistError extends _ExtendableError2.default {
  constructor(id) {
    super(`location: ${id} does not exist`);

    this.id = id;
  }
}
exports.default = LocationDoesNotExistError;